//init store

/**
 * `localStorage` GUARDA TEXTO, Y ESO ES TODO EL BUG DE ESTE ARCHIVO.
 *
 * `localStorage.setItem("school", undefined)` no deja un hueco: deja la
 * palabra "undefined", nueve letras que `getItem` devuelve como string y que
 * son `true` en cualquier `if`. Lo mismo con `null` cuando el servidor
 * responde `"school": null`, que es lo que responde para toda cuenta sin
 * colegio.
 *
 * Qué costó: ese texto viajaba como `school_id` al alta con Google, el
 * servidor hacía `get_object_or_404` con él y devolvía 404 DESPUÉS de crear
 * la cuenta. Sin sesión, sin origen, sin CompleteRegistration y sin
 * `sign_up`. Cinco altas perdidas en doce días, y bastaba con haber cerrado
 * sesión una vez en ese navegador.
 *
 * `guardar` y `leer` son las dos mitades del arreglo, y las dos hacen falta:
 * `guardar` impide envenenar el almacén de aquí en adelante, y `leer` limpia
 * los navegadores que ya lo tienen envenenado —que son todos los de la gente
 * que ya intentó registrarse—. Sin `leer`, este arreglo no llega a nadie que
 * no borre sus datos de sitio a mano.
 */
const NO_ES_UN_VALOR = ["undefined", "null", "NaN"];

function leer(clave) {
  const crudo = localStorage.getItem(clave);
  return crudo !== null && NO_ES_UN_VALOR.indexOf(crudo) > -1 ? null : crudo;
}

function guardar(clave, valor) {
  if (valor === undefined || valor === null) {
    localStorage.removeItem(clave);
    return;
  }
  localStorage.setItem(clave, valor);
}

const state = {
  token: leer("token"),
  first_name: leer("first_name"),
  last_name: leer("last_name"),
  email: leer("email"),
  thumbnail: leer("thumbnail"),
  country: leer("country"),
  points: leer("points"),
  school: leer("school"),
  year: leer("year"),
  schoolLevel: leer("schoolLevel"),
  grade: leer("grade"),
  subtag: leer("subtag"),
  notifications: [],
  new_notifications: 0,
  missions: [],
  user_level: 0,
  currentExp: 0,
  nextLevelExp: 0,
  user_id: leer("user_id"),
  anonID: leer("anonID"),
  useMaterials: leer("useMaterials"),
  useAssisted: leer("useAssisted"),
  isAdmin: leer("isAdmin"),
  buy: false,
  // localStorage stores "false" as a string, which is truthy — every consumer
  // reads isPaid as a boolean (`!isPaid`), so parse it back on hydration.
  isPaid: localStorage.getItem("isPaid") === "true",
  socket: { isConnected: false },
  online: leer("isAdmin"),
  hasEnrolled: leer("hasEnrolled"),
  eurekaModal: false,
  eurekaUses: leer("eurekaUses"),
  planificationsUses: leer("planificationsUses"),
  materialsUses: leer("materialsUses"),
  testsUses: leer("testsUses"),
  documentsUses: leer("documentsUses"),
  codesReferredModal: false,
};
const mutations = {
  setUser(state, payload) {
    state.token = payload.token;
    guardar("token", payload.token);
    state.first_name = payload.first_name;
    guardar("first_name", payload.first_name);
    state.last_name = payload.last_name;
    guardar("last_name", payload.last_name);
    state.email = payload.email;
    guardar("email", payload.email);
    state.thumbnail = payload.thumbnail;
    guardar("thumbnail", payload.thumbnail);
    state.country = payload.country;
    guardar("country", payload.country);
    state.points = payload.points;
    guardar("points", payload.points);
    // El servidor responde `"school": null` para toda cuenta sin colegio, o
    // sea para toda cuenta recien creada. Sin `guardar`, esto dejaba la
    // palabra "null" en el almacen y la recarga siguiente ya salia envenenada,
    // sin necesidad de cerrar sesion.
    state.school = payload.school;
    guardar("school", payload.school);
    state.user_id = payload.id;
    guardar("user_id", payload.id);
    state.schoolLevel = payload.level;
    guardar("schoolLevel", payload.school_level);
    state.isAdmin = payload.isAdmin;
    guardar("isAdmin", payload.isAdmin);
    state.user_level = payload.level;
    guardar("user_level", payload.level);
    state.currentExp = payload.current_level_exp;
    guardar("currentExp", payload.current_level_exp);
    state.nextLevelExp = payload.next_level_experience;
    guardar("nextLevelExp", payload.next_level_experience);
    state.isPaid = payload.isPaid;
    guardar("isPaid", payload.isPaid);
    // `has_enrolled` no viene en la respuesta del alta con Google, asi que
    // aqui llegaba `undefined` de verdad. Es el segundo "undefined" guardado
    // de este archivo, con la diferencia de que este no necesitaba un cierre
    // de sesion para aparecer.
    state.hasEnrolled = payload.has_enrolled;
    guardar("hasEnrolled", payload.has_enrolled);
    state.eurekaUses = payload.eurekaUses;
    guardar("eurekaUses", payload.eurekaUses);
    state.planificationsUses = payload.planificationsUses;
    guardar("planificationsUses", payload.planificationsUses);
    state.materialsUses = payload.materialsUses;
    guardar("materialsUses", payload.materialsUses);
    state.testsUses = payload.testsUses;
    guardar("testsUses", payload.testsUses);
    state.documentsUses = payload.documentsUses;
    guardar("documentsUses", payload.documentsUses);
  },
  setUserEmpty(state) {
    state.token = "";
    localStorage.setItem("token", "");
    state.first_name = "";
    localStorage.setItem("first_name", "");
    state.last_name = "";
    localStorage.setItem("last_name", "");
    state.email = "";
    localStorage.setItem("email", "");
    state.thumbnail = "";
    localStorage.setItem("thumbnail", "");
    state.country = 0;
    localStorage.setItem("country", 0);
    state.points = 0;
    localStorage.setItem("points", 0);
    // Borrar, no escribir. Esta era LA linea: `setItem("school", undefined)`
    // dejaba la palabra "undefined", y el siguiente registro con Google en
    // este navegador la mandaba como `school_id` y se caia con 404 despues de
    // crear la cuenta.
    state.school = null;
    localStorage.removeItem("school");
    state.subtag = "";
    guardar("subtag", "");
    state.schoolLevel = "";
    localStorage.removeItem("schoolLevel");
    state.user_level = 0;
    localStorage.setItem("user_level", 0);
    state.currentExp = 0;
    localStorage.setItem("currentExp", 0);
    state.nextLevelExp = 0;
    localStorage.setItem("nextLevelExp", 0);
    state.isAdmin = false;
    localStorage.setItem("isAdmin", false);
    state.useMaterials = false;
    localStorage.setItem("useMaterials", false);
    state.useAssisted = false;
    localStorage.setItem("useAssisted", false);
    state.isPaid = false;
    localStorage.setItem("isPaid", false);
    state.hasEnrolled = false;
    localStorage.setItem("hasEnrolled", false);
    state.eurekaUses = 0;
    localStorage.setItem("eurekaUses", 0);
    state.planificationsUses = 0;
    localStorage.setItem("planificationsUses", 0);
    state.materialsUses = 0;
    localStorage.setItem("materialsUses", 0);
    state.testsUses = 0;
    localStorage.setItem("testsUses", 0);
    state.documentsUses = 0;
    localStorage.setItem("documentsUses", 0);
    window.google.accounts.id.disableAutoSelect();
  },
  setOnline(state, online) {
    state.online = online;
    guardar("online", online);
  },
  setPoints(state, payload) {
    state.points = payload.points;
    guardar("points", payload.points);
  },
  setCountry(state, payload) {
    state.country = payload.country;
    guardar("country", payload.country);
  },
  setSchool(state, school) {
    // Por `guardar` y no por `setItem`: los dos llamadores publicos de esto
    // le pasan un `data.school` que puede llegar nulo (layouts de sales y de
    // botpie-assistant, en el socket `school_created`).
    state.school = school;
    guardar("school", school);
  },
  setYear(state, year) {
    state.year = year;
    guardar("year", year);
  },
  setGrade(state, grade) {
    state.grade = grade;
    guardar("grade", grade);
  },
  setSubtag(state, payload) {
    state.subtag = payload.subtag;
    guardar("state", payload.subtag);
  },
  setNotifications(state, payload) {
    state.notifications = payload;
  },
  addNotification(state, payload) {
    state.notifications = [...payload, ...state.notifications];
  },
  pushNotification(state, payload) {
    state.notifications = [...state.notifications, ...payload];
  },
  setNewNotifications(state, count) {
    state.new_notifications = count;
  },
  setMissions(state, payload) {
    state.missions = payload;
  },
  setSchoolLevel(state, level) {
    state.schoolLevel = level;
    guardar("schoolLevel", level);
  },
  setMaterials(state, useMaterials) {
    state.useMaterials = useMaterials;
    guardar("useMaterials", useMaterials);
  },
  setAssisted(state, useAssisted) {
    state.useAssisted = useAssisted;
    guardar("useAssisted", useAssisted);
  },
  setEurekaUses(state, eurekaUses) {
    state.eurekaUses = eurekaUses;
    guardar("eurekaUses", eurekaUses);
  },
  setPlanificationsUses(state, planificationsUses) {
    state.planificationsUses = planificationsUses;
    guardar("planificationsUses", planificationsUses)
  },
  setMaterialsUses(state, materialsUses) {
    state.materialsUses = materialsUses;
    guardar("materialsUses", materialsUses);
  },
  setTestsUses(state, testsUses) {
    state.testsUses = testsUses;
    guardar("testsUses", testsUses);
  },
  setDocumentsUses(state, documentsUses) {
    state.documentsUses = documentsUses;
    guardar("documentsUses", documentsUses);
  },
  openEurekaModal(state) {
    state.eurekaModal = !state.eurekaModal;
  },
  setAnonID(state, ID) {
    state.anonID = ID;
    guardar("anonID", ID);
  },
  changeBuy(state) {
    state.buy = !state.buy;
    localStorage.setItem("buy", state.buy);
  },
  changeCodesReferredModal(state) {
    state.codesReferredModal = !state.codesReferredModal;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
